module.exports = __webpack_public_path__ + "static/media/theoremreach.10e0069e.jpg";